import * as React from 'react';
import { cn } from '@/lib/utils';

const DGLesson = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-dg-lesson',
      // Estilo base
      'flex flex-col gap-3',
      className
    )}
    {...props}
  />
));
DGLesson.displayName = 'DGLesson';

const DGLessonRow = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-dg-lesson-row',
      // Estilo base
      'flex flex-wrap items-center',
      'cursor-pointer rounded-xl',
      'hover:bg-bright',
      className
    )}
    {...props}
  />
));
DGLessonRow.displayName = 'DGLessonRow';

const DGLessonTd = React.forwardRef(({ className, variant, ...props }, ref) => {
  const baseClasses = 'p-2.5 w-[120px] flex-grow flex items-center gap-1';

  const variantClasses = {
    files: 'flex-grow-0 w-[120px]',
    time: 'flex-grow-0 w-[84px]',
    title: 'w-full sm:w-auto'
  };

  return (
    <div
      ref={ref}
      className={cn(
        'c-dg-lesson-td',
        // Estilo base
        baseClasses,
        variant && variantClasses[variant],
        className
      )}
      {...props}
    />
  );
});
DGLessonTd.displayName = 'DGLessonTd';

const DGLessonCheck = React.forwardRef(({ className, isChecked = false, ...props }, ref) => {
  const checkSvgUrl =
    "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='4' stroke-linecap='round' stroke-linejoin='round' class='feather feather-check'%3E%3Cpolyline points='20 6 9 17 4 12'%3E%3C/polyline%3E%3C/svg%3E";

  const checkBgImage = `url("${checkSvgUrl}")`;

  const baseClasses = cn('c-dg-lesson-check', 'flex-shrink-0 inline-block w-3 h-3', 'bg-[#CCD2E0] bg-no-repeat bg-center bg-contain', 'border border-solid border-[#5D6A86] rounded-full', className);

  const checkedClasses = 'border-success bg-success bg-[length:0.6em_0.6em]';

  const backgroundStyle = isChecked ? { backgroundImage: checkBgImage } : {};

  return (
    <span
      ref={ref}
      className={cn(baseClasses, isChecked ? checkedClasses : '')}
      style={backgroundStyle}
      role="checkbox"
      aria-checked={isChecked}
      {...props}
    />
  );
});
DGLessonCheck.displayName = 'DGLessonCheck';

const DGLessonTitle = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn('c-dg-lesson-title', 'mb-0 text-sm font-light', 'truncate', 'text-primary-dark', 'w-[110px] flex-grow', className)}
    {...props}
  />
));
DGLessonTitle.displayName = 'DGLessonTitle';

const DGLessonText = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn('c-dg-lesson-text', 'mb-0 text-sm font-light', 'text-neutral', className)}
    {...props}
  />
));
DGLessonText.displayName = 'DGLessonText';

const DGLessonLink = React.forwardRef(({ className, ...props }, ref) => (
  <a
    ref={ref}
    className={cn('c-dg-lesson-link', 'mb-0 text-sm font-light', 'text-neutral', 'underline', className)}
    {...props}
  />
));
DGLessonLink.displayName = 'DGLessonLink';

export { DGLesson, DGLessonRow, DGLessonTd, DGLessonCheck, DGLessonTitle, DGLessonText, DGLessonLink };
